import { RouteObject } from 'react-router'
import { lazy, Suspense } from 'react'
import { ProtectedRoutes } from '@/common/layouts/ProtectedRoutes.tsx'
import { SuspenseLoading } from '@/common/components/SuspenseLoading.tsx'

const RewardExercisePage = lazy(() => import('@/pages/reward-exercise/reward-exercise-main.tsx'))

export const rewardExerciseRoutes: RouteObject = {
  path: 'reward-exercise',
  element: <ProtectedRoutes
    requiredPermissions={[{
      moduleName: 'employee-data',
      functionName: 'access-reward-exercise',
    }]}
  />,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<SuspenseLoading />}>
          <RewardExercisePage />
        </Suspense>
      ),
    },
  ],
}